var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageLoader',{attrs:{"storage":_vm.appLoading}}),(_vm.ServerError)?_c('ServerError'):_vm._e(),_c('v-layout',{attrs:{"wrap":"","justify-center":"","px-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('ProductDetails',{attrs:{"productData":_vm.productData,"productPhotos":_vm.productPhotos,"Sizes":_vm.Sizes}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }